import { createTRPCNuxtClient, httpLink } from "trpc-nuxt/client";
import superjson from "superjson";
import type { AppRouter } from "../server/api/trpc/[trpc]";
import { transformer } from "../utils";

export default defineNuxtPlugin(() => {
  const client = createTRPCNuxtClient<AppRouter>({
    links: [
      httpLink({
        url: "/api/trpc",
        // maxURLLength: 1500,
      }),
    ],
    transformer: transformer,
  });

  return {
    provide: {
      client,
    },
  };
});
